// jobtypes/grid/filters.tsx
import React, { useMemo } from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { gqlGetMaterials } from '../graphql';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  const like = (s: string) => ({ $like: `%${s}%` });
  const or: any[] = [];
  if (values?.searchText?.trim()) {
    or.push({ description: like(values.searchText) });
    or.push({ code: like(values.searchText) });
    or.push({ '$material.name$': like(values.searchText) });
  }
  // add materialId IN (matched ids)
  // if (Array.isArray(values?.materialIds) && values.materialIds.length > 0) {
  //   or.push({ materialId: { $in: values.materialIds } });
  // }
  const where = or.length ? { $or: or } : {};
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();
  const [fetchMaterials] = useLazyQuery(gqlGetMaterials, { fetchPolicy: 'network-only' });

  async function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    const search = values?.searchText?.trim();
    let materialIds: number[] = [];

    if (search) {
      const where = JSON.stringify({ name: { $like: `%${search}%` } });
      const { data } = await fetchMaterials({ variables: { where, limit: 50 } });
      materialIds = (data?.getMaterials?.data ?? []).map((m: any) => m.id);
    }

    setSubmitting(false);
    onChange({ ...values, materialIds });
  }

  const filters = useMemo(
    () => ({
      searchText: initialValues?.searchText ?? '',
    }),
    [initialValues?.searchText],
  );

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Περιγραφή, Κωδικός, Υλικό)')}
          type="search"
          disable={disable}
          tooltip={'Περιγραφή, Κωδικός, Υλικό'}
        />
      </Row>
    </FormFilterCard>
  );
};

